/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */
import { fromJS } from 'immutable';

import { FYRK_LOADED } from './constants';

// The initial state of the App
const initialState = fromJS({
  fyrk: '',
});

function fyrkSingleReducer(state = initialState, action) {
  switch (action.type) {
    case FYRK_LOADED:
      return state.set('fyrk', action.fyrk);
    default:
      return state;
  }
}

export default fyrkSingleReducer;
